import { Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { SupportedThemesT, ThemeImagePipe } from '@core/theme-util';
import { DividerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-email-fixed-signature',
  templateUrl: './email-fixed-signature.component.html',
  styleUrls: ['./email-fixed-signature.component.less'],
  imports: [TranslatePipe, DividerComponent, ThemeImagePipe],
})
export class EmailFixedSignatureComponent {
  public threadTheme = input<SupportedThemesT>('light');
}
